import { render, staticRenderFns } from "./NPCDialogue.vue?vue&type=template&id=e2d11f72&"
import script from "./NPCDialogue.vue?vue&type=script&lang=js&"
export * from "./NPCDialogue.vue?vue&type=script&lang=js&"
import style0 from "./NPCDialogue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NPCDialogue.vue"
export default component.exports